<template>
  <div class="wrapper wrapper-content">
    <div class="ibox float-e-margins">
      <div class="ibox-title">
        <h5>Site Checker</h5>
        <div class="ibox-tools">
          <input type="text" name="domain" id="" class="pretty-input" placeholder="Domain" v-model="addDomain">
          <select name="country" class="pretty-input m-l-sm" v-model="addCountry">
              <option value="us">https://www.google.com</option>
              <option value="uk">https://www.google.co.uk</option>
              <option value="ca">https://google.ca</option>
              <option value="de">https://google.de</option>
              <option value="fr">https://google.fr</option>
              <option value="es">https://google.es</option>
              <option value="br">https://google.com.br</option>
              <option value="mx">https://google.com.mx</option>
              <option value="in">https://google.co.in</option>
              <option value="jp">https://google.co.jp</option>
              <option value="cn">https://google.cn</option>
              <option value="au">https://google.com.au</option>
          </select>
          <label for="ignoreCache" class="m-l-sm">Ignore Cache</label>
          <input type="checkbox" name="ignoreCache" id="ignoreCache" title="Ignore Cache" v-model="ignoreCache">
          <button class="btn btn-primary btn-xs m-l-sm" @click="addOrder">Add Order</button>
        </div>
      </div>
      <div class="ibox-content table-responsive col-lg-12">
        <div class="row" v-if="user.admin">
          <div class="col-lg-3 m-b-sm">
            <label for="showAll">Show all orders:</label>
            <input type="checkbox" name="all" id="showAll" v-model="showAll" @change="getOrders">
          </div>
        </div>
        <table class="table table-striped table-bordered table-hover dataTables-example" v-if="orders">
          <thead>
          <tr>
            <th>Order</th>
            <th>Data</th>
            <th>User</th>
            <th>Client</th>
            <th>Remote Id</th>
            <th>Time Started</th>
            <th>Time Completed</th>
            <th class="col-lg-1">Urls</th>
            <th class="col-lg-1">
              Actions
              <i class="fa fa-refresh pull-right pointer" @click="getOrders"></i>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="order in orders" :key="order.id">
            <td>
              <i class="fa fa-play blue" title="Processing" v-if="order.status === 'processing'" />
              <i class="fa fa-clock orange" title="Added" v-if="order.status === 'added'" />
              <i class="fa fa-check green" title="Completed" v-if="order.status === 'completed'" />
              {{ order.id }}
            </td>
            <td>
              {{ order.payload.url }} [{{order.payload.country}}]
            </td>
            <td class="center">{{ order.user ? order.user.username : '/' }}</td>
            <td class="center">{{ order.client || '/' }}</td>
            <td class="center">{{ order.remoteId }}</td>
            <td>
              <span v-if="order.startTime">{{ $moment(order.startTime.date).format('DD.MM. HH:mm') }}</span>
              <span v-else>/</span>
            </td>
            <td>
              <span v-if="order.endTime">{{ $moment(order.endTime.date).format('DD.MM. HH:mm') }}</span>
              <span v-else>/</span>
            </td>
            <td class="center"><span v-if="order.status !== 'completed'">{{ order.resultsStatus.completed }} / </span>{{ order.payload.length }}</td>
            <td>
              <a
                v-if="order.status === 'completed'"
                download
                title="JSON"
                :href="'https://toolbox.aphex.me/toolbox/seo/site-checker/order/' + order.id + '/result'"><i class="fab fa-js-square"></i></a>
              <a
                v-if="order.status === 'completed'"
                download
                title="CSV"
                :href="'https://toolbox.aphex.me/toolbox/seo/site-checker/order/' + order.id + '/results'"><i class="fas fa-download"></i></a>
              <span v-else>
                <input type="checkbox" name="active" v-model="order.active" @change="changeActiveStatus(order)">
              </span>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th>Order</th>
            <th>Data</th>
            <th>User</th>
            <th>Client</th>
            <th>Remote Id</th>
            <th>Time Started</th>
            <th>Time Completed</th>
            <th class="col-lg-1">Urls</th>
            <th class="col-lg-1">Actions</th>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'SiteChecker',
  data () {
    return {
      addDomain: '',
      addCountry: 'us',
      user: this.$store.state.user,
      showAll: false,
      ignoreCache: false,
      orders: []
    }
  },
  mounted () {
    this.getOrders()
  },
  methods: {
    getOrders () {
      axios.get('/toolbox/seo/site-checker/orders?users=' + (this.showAll === true ? 'all' : 'me'))
        .then(r => {
          this.orders = r.data.data
        })
        .catch(e => {
          this.$toastr.error(e, 'With great sadness...')
        })
    },
    addOrder () {
      if (this.addDomain.length < 5) {
        this.$toastr.error('That\'s a really shitty domain name (It\'s actually not a domain name at all...', 'Err, don\'t think so...')
        return
      }
      axios.post('/toolbox/seo/site-checker', {
        domain: this.addDomain,
        country: this.addCountry,
        ignoreCache: this.ignoreCache
      })
        .then(r => {
          this.addDomain = ''
          this.ignoreCache = false
          this.getOrders()
          this.$toastr.success('Good stuff', 'Ya man!')
        })
        .catch(e => {
          this.$toastr.error(e, 'Ouch')
        })
    },
    changeActiveStatus (order) {
      axios.patch('/toolbox/order/' + order.id, {
        'active': order.active
      })
        .then(r => {
          this.$toastr.success('Well done, you\'re really good at this', 'Ya man!')
        })
        .catch(e => {
          this.$toastr.error(e)
        })
    }
  }
}
</script>
<style>
.center {
  text-align: center;
}
.green {
  color: green;
}
.blue {
  color: #0c73b8;
}
.orange {
  color: orange;
}
.pointer {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Std/SiteChecker.vue